import { render, staticRenderFns } from "./PurchaseShippingCompanies.vue?vue&type=template&id=5ede893d&"
import script from "./PurchaseShippingCompanies.vue?vue&type=script&lang=ts&"
export * from "./PurchaseShippingCompanies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports